import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

import { SgsTuvDto } from './sgs-tuv-ins.dto';



export class AllsgsTuvResponseModel extends GlobalResponseObject {
    data?: SgsTuvDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: SgsTuvDto[]) {
        super(status, intlCode, internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}